<template>
  <div v-if="flag" v-html="require(`./assets/svg/flags/${name}.svg`)"></div>
  <div v-else-if="language !== ''" v-html="require(`./assets/svg/sdgs/${language}/SDG-${name}.svg`)"></div>
  <div v-else v-html="require(`./assets/svg/${name}.svg`)"></div>
</template>

<script>
export default {
  name: 'icon',
  props: {
    name: [String, Number],
    flag: {
      type: Boolean,
      default: false
    },
    language: {
      type: String,
      default: ''
    }
  }
}
</script>
